import React from "react"


import EmployeeRequestControl from "../../components/LaborAccessRequest/EmployeeRequestControl/EmployeeRequestControl"


function EmployeeRequestControlPage() {
  return <EmployeeRequestControl />
}

export default EmployeeRequestControlPage
